import React from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

function About() {
    return (
        <>
            <Navbar />
            <section id="center" className="center_o pt-5 pb-5 bg_light">
                <div className="container-xl">
                    <div className="row center_o1 text-center">
                        <div className="col-md-12">
                            <h1>ABOUT US</h1>
                            <h6 className="d-inline-block mb-0 col_yell">
                                <a href="#">Home</a> <span className="mx-2 text-muted">/</span>{" "}
                                About Us
                            </h6>
                        </div>
                    </div>
                </div>
            </section>
            <section id="about" className="p_3">
                <div className="container-xl">
                    <div className="row about_1">
                        <div className="col-md-6">
                            <div className="about_1l">
                                <div className="about_1li row">
                                    <div className="col-md-6">
                                        <div className="about_1lil text-center bg_light rounded_5 px-3">
                                            <h1 className="mb-0">
                                                12 +<span className="fs-6 d-block">Years Experience</span>
                                            </h1>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="about_1lir">
                                            <div className="grid clearfix">
                                                <figure className="effect-jazz mb-0">
                                                    <a href="#">
                                                        <img
                                                            src="img/White and Green Simple  Professional Business Project Presentation-1.png"
                                                            height={210}
                                                            className="w-100"
                                                            alt="abc"
                                                        />
                                                    </a>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="about_1li1 row mt-4">
                                    <div className="col-md-12">
                                        <div className="grid clearfix">
                                            <figure className="effect-jazz mb-0">
                                                <a href="#">
                                                    <img src="img/White and Green Simple  Professional Business Project Presentation-1.png" className="w-100" alt="abc" />
                                                </a>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="about_1r mt-5">
                                <h4 className="col_blue">About Us</h4>
                                <h1 className="mt-3">
                                    We Are Best Electrical Store in Town Since 2010
                                </h1>
                                <p className="mt-3">
                                    Irfan Electricals provides quality electrical products and reliable services.
                                </p>
                                <div className="about_1ri row mt-4">
                                    <div className="col-md-6">
                                        <div className="about_1ril">
                                            <h6>
                                                <i className="fa fa-check-circle col_blue me-1 align-middle" />{" "}
                                                International Brands
                                            </h6>
                                            <h6 className="mt-3">
                                                <i className="fa fa-check-circle col_blue me-1 align-middle" />{" "}
                                                Have heen certified
                                            </h6>
                                            <h6 className="mt-3">
                                                <i className="fa fa-check-circle col_blue me-1 align-middle" />{" "}
                                                Quality of our research
                                            </h6>
                                            <h6 className="mt-3">
                                                <i className="fa fa-check-circle col_blue me-1 align-middle" />{" "}
                                                Breadth of our capabilities
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="about_1ril">
                                            <h6>
                                                <i className="fa fa-check-circle col_blue me-1 align-middle" />{" "}
                                                Trustworthy
                                            </h6>
                                            <h6 className="mt-3">
                                                <i className="fa fa-check-circle col_blue me-1 align-middle" />{" "}
                                                High integrity
                                            </h6>
                                            <h6 className="mt-3">
                                                <i className="fa fa-check-circle col_blue me-1 align-middle" />{" "}
                                                Providing The best product
                                            </h6>
                                            <h6 className="mt-3">
                                                <i className="fa fa-check-circle col_blue me-1 align-middle" />{" "}
                                                Global reach of our business
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <h6 className="mb-0 mt-4 text-uppercase">
                                    <a className="button" href="/about">
                                        About Us
                                    </a>
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="spec" className="p_3 bg_light">
                <div className="container-xl">
                    <div className="row spec_1">
                        <div className="col-md-3 col-sm-6">
                            <div className="spec_1i text-center">
                                <span className="font_60 col_yell">
                                    <i className="fa fa-gg" />
                                </span>
                                <h2>
                                    1,400 <span className="col_yell">+</span>
                                </h2>
                                <h6 className="text-muted mb-0">Brands</h6>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <div className="spec_1i text-center">
                                <span className="font_60 col_yell">
                                    <i className="fa fa-users" />
                                </span>
                                <h2>
                                    688 <span className="col_yell">+</span>
                                </h2>
                                <h6 className="text-muted mb-0">Customers</h6>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <div className="spec_1i text-center">
                                <span className="font_60 col_yell">
                                    <i className="fa fa-check-square-o" />
                                </span>
                                <h2>
                                    876 <span className="col_yell">+</span>
                                </h2>
                                <h6 className="text-muted mb-0">Products</h6>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <div className="spec_1i text-center">
                                <span className="font_60 col_yell">
                                    <i className="fa fa-trophy" />
                                </span>
                                <h2>
                                    86 <span className="col_yell">+</span>
                                </h2>
                                <h6 className="text-muted mb-0">Awards</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

        </>
    );
}

export default About;
